import styled from "styled-components";

export const Container = styled.div`
    max-height: 5000px;
    transition: max-height 0.5s ease-in-out;
`